import React from "react";
import {
  Skeleton,
  SkeletonText,
  SkeletonButton,
  SkeletonBadge,
} from "../Skeleton";
import { cn } from "../../lib/utils";

interface DetailPageSkeletonProps {
  showBackButton?: boolean;
  showActions?: boolean;
  showMetadata?: boolean;
  className?: string;
}

export const DetailPageSkeleton: React.FC<DetailPageSkeletonProps> = ({
  showBackButton = true,
  showActions = true,
  showMetadata = true,
  className,
}) => {
  return (
    <div className={cn("min-h-screen py-4", className)}>
      <div className="mx-auto">
        {/* Header */}
        <div className="mb-6">
          {showBackButton && (
            <SkeletonButton width={150} height={40} className="mb-4" />
          )}

          <div className="bg-white rounded-xl shadow-lg border border-tiber-600 p-6">
            {/* Title Section */}
            <div className="flex items-start justify-between mb-4">
              <div className="flex-1">
                <div className="flex items-center gap-3 mb-3">
                  <Skeleton
                    variant="rectangular"
                    width={48}
                    height={48}
                    className="rounded-lg"
                  />
                  <div className="flex-1">
                    <Skeleton
                      variant="text"
                      width="70%"
                      height={36}
                      className="mb-2"
                    />
                    <div className="flex items-center gap-2">
                      <SkeletonBadge />
                      <SkeletonBadge />
                      <SkeletonBadge />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Metadata */}
            {showMetadata && (
              <div className="flex items-center gap-6 mb-6">
                <Skeleton variant="text" width={200} height={20} />
                <Skeleton variant="text" width={150} height={20} />
              </div>
            )}

            {/* Description */}
            <div className="mb-6">
              <Skeleton
                variant="text"
                width="30%"
                height={28}
                className="mb-3"
              />
              <SkeletonText lines={4} />
            </div>

            {/* Instructions */}
            <div className="mb-6">
              <Skeleton
                variant="text"
                width="25%"
                height={28}
                className="mb-3"
              />
              <div className="bg-romance-50 rounded-lg p-4 border border-tiber-200">
                <SkeletonText lines={3} />
              </div>
            </div>

            {/* Content */}
            <div className="mb-6">
              <Skeleton
                variant="text"
                width="20%"
                height={28}
                className="mb-3"
              />
              <div className="bg-white rounded-lg p-4 border border-tiber-200">
                <SkeletonText lines={5} />
              </div>
            </div>

            {/* Actions */}
            {showActions && (
              <div className="flex items-center gap-4 pt-6 border-t border-tiber-200">
                <SkeletonButton width={180} height={44} />
                <SkeletonButton width={160} height={44} />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
